"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
/**
* @export
* @enum {string}
*/
var TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTransferStatusEnum;
(function (TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTransferStatusEnum) {
    TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTransferStatusEnum["TransferUndefined"] = "TRANSFER_UNDEFINED";
    TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTransferStatusEnum["TransferSuccess"] = "TRANSFER_SUCCESS";
    TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTransferStatusEnum["TransferFailed"] = "TRANSFER_FAILED";
    TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTransferStatusEnum["TransferCancelled"] = "TRANSFER_CANCELLED";
    TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTransferStatusEnum["TransferPending"] = "TRANSFER_PENDING";
    TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTransferStatusEnum["InProgress"] = "IN_PROGRESS";
})(TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTransferStatusEnum = exports.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTransferStatusEnum || (exports.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTransferStatusEnum = {})); /**
* @export
* @enum {string}
*/
var TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum;
(function (TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum) {
    TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum["TrainUndefined"] = "TRAIN_UNDEFINED";
    TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum["Autopilot"] = "AUTOPILOT";
    TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum["TrainDone"] = "TRAIN_DONE";
    TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum["DoneDescriptive"] = "DONE_DESCRIPTIVE";
    TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum["DoneFeatureEngineering"] = "DONE_FEATURE_ENGINEERING";
    TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum["DonePredictive"] = "DONE_PREDICTIVE";
    TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum["TrainDraft"] = "TRAIN_DRAFT";
    TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum["TrainFailed"] = "TRAIN_FAILED";
    TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum["Fetching"] = "FETCHING";
    TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum["TrainInProgress"] = "TRAIN_IN_PROGRESS";
    TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum["Postprocessing"] = "POSTPROCESSING";
    TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum["Preprocessing"] = "PREPROCESSING";
    TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum["TrainQueued"] = "TRAIN_QUEUED";
    TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum["QueuedForFetching"] = "QUEUED_FOR_FETCHING";
    TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum["QueuedForPostprocessing"] = "QUEUED_FOR_POSTPROCESSING";
    TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum["RequestToDelete"] = "REQUEST_TO_DELETE";
    TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum["Resizing"] = "RESIZING";
    TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum["RunningDescriptive"] = "RUNNING_DESCRIPTIVE";
    TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum["RunningFeatureEngineering"] = "RUNNING_FEATURE_ENGINEERING";
    TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum["RunningPredictive"] = "RUNNING_PREDICTIVE";
    TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum["TrainSuccess"] = "TRAIN_SUCCESS";
    TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum["TrainTimedOut"] = "TRAIN_TIMED_OUT";
})(TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum = exports.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum || (exports.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum = {}));
function TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseFromJSON(json) {
    return TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseFromJSONTyped(json, false);
}
exports.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseFromJSON = TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseFromJSON;
function TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'transferStatus': !runtime_1.exists(json, 'transferStatus') ? undefined : json['transferStatus'],
        'trainStatus': !runtime_1.exists(json, 'trainStatus') ? undefined : json['trainStatus'],
    };
}
exports.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseFromJSONTyped = TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseFromJSONTyped;
function TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'transferStatus': value.transferStatus,
        'trainStatus': value.trainStatus,
    };
}
exports.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseToJSON = TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseToJSON;
